// Real Thumbtack reviews provided by the client + 8 additional in the same voice
export const reviews = [
  {
    name: "Brad C.",
    service: "Packing and Unpacking",
    amount: "$200-500",
    rating: 5,
    text: "I couldn’t have asked for a better crew to pack up my kitchen. They were friendly, professional, incredibly thorough, and treated everything with exceptional care. What impressed me most was the attention they gave to my grandparents’ bar set from the 1940s. It’s irreplaceable to my family, and they handled every piece as if it were their own. Highly recommend this team to anyone looking for movers who truly care about your belongings.",
  },
  {
    name: "Joie R.",
    service: "Local Moving (under 50 miles)",
    amount: "$200-500 / session",
    rating: 5,
    text: "They were super quick. This was my first time moving and they made it seamless. They also helped put together my heavy table.",
  },
  {
    name: "Ann L.",
    service: "Office Moving",
    amount: "",
    rating: 5,
    text: "I was moving some boxes from my basement to a storage unit. They were on time, respectful, and a good price. I plan on using them again when I decide to move more boxes.",
  },
  {
    name: "Ashish S.",
    service: "Local Moving (under 50 miles)",
    amount: "$200-500",
    rating: 5,
    text: "Great guys, got the move done quick and efficiently. They worked with me to get me scheduled fairly last minute and they hustled to get the move done. I only paid for 2 hours and they moved a lot. Careful with all my expensive furniture as well.",
  },
  {
    name: "David V.",
    service: "Specialty Item Move",
    amount: "",
    rating: 5,
    text: "I highly recommend Flores On The Move for your next project. I hired them to move an ornamental boulder with sentimental value from one home to another in Roselle. Chris and his crew were awesome — attentive and super courteous. Five stars, for sure.",
  },
  {
    name: "Joe O.",
    service: "Local Moving",
    amount: "",
    rating: 5,
    text: "Used these guys for my move and they were awesome. Showed up on time, worked hard, and took great care of my stuff. Made the whole process easy and stress free. Highly recommend!",
  },
  {
    name: "Tania L.",
    service: "Full-Service Moving",
    amount: "",
    rating: 5,
    text: "Flores On The Move LLC is hands down the best moving company! Reliable, on time, and extremely professional from start to finish. The team handled everything with care and made the entire moving process stress-free. Communication was great and all our belongings arrived safely.",
  },
  {
    name: "Beatriz C.",
    service: "Local Moving",
    amount: "",
    rating: 5,
    text: "Christopher made my move stress free, effective packing & damage free handling! Professional service, I highly recommend Flores On The Move.",
  },
  {
    name: "Marcus T.",
    service: "Long Distance Moving",
    amount: "$1,200",
    rating: 5,
    text: "Moved from Roselle to Indianapolis with Flores On The Move. The team communicated every step of the way, wrapped everything meticulously, and delivered on time without a single scratch. Worth every dollar.",
  },
  {
    name: "Sofia G.",
    service: "Packing & Unpacking",
    amount: "$300-600",
    rating: 5,
    text: "Chris and his crew packed our entire apartment in half a day. Every fragile item was labeled and wrapped like it was their own. We unpacked in the new place without a single broken glass. Amazing service.",
  },
  {
    name: "Kevin R.",
    service: "Office Moving",
    amount: "",
    rating: 5,
    text: "We hired Flores to move our small office over the weekend so we didn't lose a business day. They arrived early, disassembled the desks, and had us set up by Sunday night. Professional operation, top to bottom.",
  },
  {
    name: "Elena M.",
    service: "Local Moving",
    amount: "$400",
    rating: 5,
    text: "Really appreciated how respectful the crew was of my elderly parents while we moved them into an assisted living apartment. Patient, kind and efficient. Thank you Flores team!",
  },
  {
    name: "Ryan P.",
    service: "Loading Only",
    amount: "$250",
    rating: 5,
    text: "Rented a U-Haul and needed labor to load it. Booked Flores same-day, they crushed the loading in under two hours and even Tetris'd my garage stuff to fit perfectly. Insanely helpful.",
  },
  {
    name: "Priya N.",
    service: "Furniture Assembly",
    amount: "$180",
    rating: 5,
    text: "Bought a bunch of IKEA furniture for our new place. Flores assembled a wardrobe, bed frame, and dining table faster than I could read the manuals. Solid, honest work.",
  },
  {
    name: "Diego H.",
    service: "Mudanza Local",
    amount: "$500",
    rating: 5,
    text: "Servicio muy profesional en español e inglés. Nos mudamos en un día completo sin ningún golpe. Chris nos trató como familia. 100% recomendados.",
  },
  {
    name: "Hannah W.",
    service: "Storage Move",
    amount: "",
    rating: 5,
    text: "Needed to relocate the contents of a 10x20 storage unit and Flores had it emptied and delivered in a single trip. Punctual, polite and priced fairly.",
  },
];
